import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import { RestrictedAccess } from "./private-component/RestrictedAccess";
import AllFlexcareBookings from "./pages/AllFlexcareBookings";
import AllUsers from "./pages/AllUsers";
import ProgramsPricing from "./pages/ProgramPrices";
import Statistics from "./pages/statistics/Statistics";
import Invoices from "./pages/AllInvoices"
import WinterCampBookings from "./pages/WinterCampBookings";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route element={<RestrictedAccess />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/flexcare-bookings" element={<AllFlexcareBookings />} />
          <Route path="/all-users" element={<AllUsers />} />
          <Route path="/program-prices" element={<ProgramsPricing />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/winter-camp-bookings" element={<WinterCampBookings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
